import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideoHistoryRoute = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("mask", {
			id: "video-halo",
			children: [/* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			}), /* @__PURE__ */ _jsxs("g", {
				transform: "translate(11, 11) scale(0.55)",
				fill: "black",
				stroke: "black",
				strokeWidth: 6,
				children: [/* @__PURE__ */ _jsx("rect", {
					x: 2,
					y: 5,
					width: 14,
					height: 12,
					rx: 3
				}), /* @__PURE__ */ _jsx("path", { d: "M16 9L21 6.5V15.5L16 13" })]
			})]
		}) }),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#video-halo)",
			children: [
				/* @__PURE__ */ _jsx("path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" }),
				/* @__PURE__ */ _jsx("path", { d: "M3 3v5h5" }),
				/* @__PURE__ */ _jsx("path", { d: "M12 7v5l4 2" })
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			transform: "translate(11, 11) scale(0.55)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 2,
				y: 5,
				width: 14,
				height: 12,
				rx: 3
			}), /* @__PURE__ */ _jsx("path", { d: "M16 9L21 6.5V15.5L16 13" })]
		})
	]
});
export default SvgVideoHistoryRoute;
